module.exports = __webpack_public_path__ + "img/airbase-gallery-6.9d96b6d3.jpg";